export default __webpack_public_path__ + "static/Agrotoken-ca7408a297b932500a671fb779b5e3b6.png";